// src/api/notificationsFnct.api.ts — SCE Issues
// Les notifications des FNC-T (lot F6, 23/10) : les messages composés par
// utils/notificationsFnct, déposés dans SCE_Envois, envoyés par le flow 6
// (docs/flows/flow-6-envoi-be.md). Rien à construire dans Power Automate.
//
// Qui fait le geste : déclaré une fois par l'appli (`definirActeurNotifications`,
// features/notifications-fnct), le compte RÉEL — pas la personne affichée en
// bascule de rôle. Tant que personne n'est déclaré (bancs d'essai), rien ne part.
//
// Toujours au mieux : la FNC-T est déjà écrite ; un échec ici est noté dans la
// console et ne remonte jamais à l'écran.

import { adresseDe } from './annuaire.api'
import { deposerLigneEnvoi } from './envoisBE.api'
import { lireReglagesNotification } from './userPrefs.api'
import { FNCT_EN_ESSAI } from '@/config/fnct.config'
import { deposerNotificationsAppli } from './cloche.api'
import { champsNotification, clocheDuGeste, messagesDuGeste, type Direct, type GesteFnct, type Personne } from '@/utils/notificationsFnct'

let acteur: Personne | null = null
let urlApp = ''

/** Qui agit dans cet onglet (null à la déconnexion) et l'adresse de l'appli. */
export function definirActeurNotifications(personne: Personne | null, url: string): void {
  acteur = personne?.upn ? personne : null
  urlApp = url.replace(/\/+$/, '')
}

export function acteurNotifications(): Personne | null {
  return acteur
}

/** L'adresse de l'appli, sans `/` final (liens des notifications, mentions comprises). */
export function urlAppNotifications(): string {
  return urlApp || window.location.origin
}

/** Adresse manquante (expert, nom repris de l'Excel) : l'annuaire, au mieux. */
async function avecAdresse(d: Direct): Promise<Direct> {
  if (d.personne.upn.trim()) return d
  const upn = await adresseDe(d.personne.nom).catch(() => '')
  return { ...d, personne: { ...d.personne, upn } }
}

/** Compose et dépose les messages des gestes ; une ligne de SCE_Envois chacun. */
export async function deposerNotificationsFnct(gestes: readonly GesteFnct[]): Promise<number> {
  const qui = acteur
  if (!qui || gestes.length === 0) return 0
  const complets = await Promise.all(gestes.map(async (g) => ({ ...g, directs: await Promise.all(g.directs.map(avecAdresse)) })))
  const ctx = { acteur: qui, urlApp, reglages: await lireReglagesNotification(), essai: FNCT_EN_ESSAI }
  const messages = complets.flatMap((g) => messagesDuGeste(g, ctx))
  // La cloche d'abord (03/11) : au mieux, elle ne retient jamais les messages.
  await deposerNotificationsAppli(complets.flatMap((g) => clocheDuGeste(g, ctx)))
  for (const m of messages) await deposerLigneEnvoi(champsNotification(m, qui.upn))
  return messages.length
}
